import { connect } from "react-redux";
import { autoAuthorize as onAutoAuthorize, AuthLevel, signOut as onSignOut, authorizeEmbedded as onAuthorizeEmbedded } from "features/auth/reducer";
import { navigateTo as onNavigateTo } from "features/global/reducer";
import App from "./App";
import { RootState } from "./rootReducer";

const mapStateToProps = (state: RootState) => ({
    authLevel: state.auth.level,
    isReady: (state.auth.level === AuthLevel.Dashboard && !!state.calendar.club) || (state.auth.level === AuthLevel.User && !!state.user.profile), // TODO(deermichel): check
    urlData: state.global.urlData,
    userRole: state.user.profile?.memberships.find((m) => m.club.id === state.calendar.club?.id)?.userRole,
    isCompanyProfile: state.user.isCompanyProfile,
    view: state.global.view,
});

const mapDispatchToProps = {
    onAuthorizeEmbedded,
    onAutoAuthorize,
    onNavigateTo,
    onSignOut,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
